var render, staticRenderFns
import script from "./ServiceWorkerUpdatePopup.vue?vue&type=script&lang=ts"
export * from "./ServiceWorkerUpdatePopup.vue?vue&type=script&lang=ts"
import style0 from "./ServiceWorkerUpdatePopup.vue?vue&type=style&index=0&id=223c5bab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c5bab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223c5bab')) {
      api.createRecord('223c5bab', component.options)
    } else {
      api.reload('223c5bab', component.options)
    }
    
  }
}
component.options.__file = "src/pwa/components/ServiceWorkerUpdatePopup.vue"
export default component.exports